import React from 'react';
import { PageTabs } from '@css-xp/base';

import { GeneratingInvoices } from './generating-invoice-tab';
import InvoiceTab from './invoice-tab';

interface Props {
  id: string;
  transactionAccountId?: string;
}

const InvoiceDetailsTabIG = ({ id, transactionAccountId }: Props) => {
  const getInvoiceDetailsTabs = () => {
    return (
      <PageTabs showAllTab={false}>
        <InvoiceTab id={id} transactionAccountId={transactionAccountId} label={'Invoices'} />
        <GeneratingInvoices
          invoiceGroupId={id}
          label="Generating Invoices"
          transactionAccountId={transactionAccountId ?? ''}
        />
      </PageTabs>
    );
  };

  return (
    <div data-testid="transaction-account-details-tab">
      <h4 style={{ marginBottom: 20, marginTop: 32 }}>Linked invoices</h4>
      {getInvoiceDetailsTabs()}
    </div>
  );
};

export default InvoiceDetailsTabIG;
